const packageJson = require("../../package.json");

const env = process.env.NODE_ENV || "development";
console.log("environment", env);
const config = require("../../secrets/config");
module.exports = {
  title: packageJson.title,
  version: packageJson.version,
  settings: {
    dense: false,
    footer: true,
    navbar: {
      show: true,
      dense: false,
      logo: true,
    },
  },
  Environment: config.Environment,
  API_ENDPOINT: config.API_ENDPOINT,
  TELEMATICS_ENDPOINT: config.TELEMATICS_ENDPOINT,
  ALERT_CONFIG_ENDPOINT: config.ALERT_CONFIG_ENDPOINT,
  LOCATION_ENDPOINT: config.LOCATION_ENDPOINT,
  SMS_ENDPOINT_NEW: config.SMS_ENDPOINT_NEW,
  ENABLE_MAP_TELEMATICS: config.ENABLE_MAP_TELEMATICS,
  GOOGLE_MAPS: config.GOOGLE_MAPS,
  GOOGLE_MAPS_API: config.GOOGLE_MAPS_API,
  NOTIFICATION_REFRESH_INTERVAL: config.NOTIFICATION_REFRESH_INTERVAL,
};
